import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { fetchAdminNotifications, markAsRead } from "../../api/endpoint";
import Loader from "../../components/loader";
import { convertMsTimeToDate } from "../../utils/format";
import { BsInfoCircle } from "react-icons/bs";
import toast from "react-hot-toast";
import DetailsModal from "./DetailsModal";

const AdminNotifications = () => {
  const navigate = useNavigate();
  const { auth } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [isViewOpen, setIsViewOpen] = useState(false);

  useEffect(() => {
    if (auth) getNotifications();
  }, [auth]);

  const getNotifications = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchAdminNotifications, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      setNotifications(response?.data?.notifications || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch notifications");
    } finally {
      setLoading(false);
    }
  };

  const markAsSeen = async (id) => {
    try {
      setLoading(true);
      await axios.post(markAsRead, { notificationIds: [id] }, { headers: { Authorization: `Bearer ${auth}` } });
      setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, seen: true } : n)));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDetails = async (notification) => {
    if (!notification.seen) {
      await markAsSeen(notification.id);
    }
    let url = "";
    switch (notification?.type) {
      case "GAME":
        url = "/game-report-details";
        break;
      case "USER":
        url = "/user-report-details";
        break;
      case "CHAT":
        url = "/chat-report-details";
        break;
      default:
        return;
    }
    navigate(url, {
      state: { reportId: notification?.reportId },
    });
    // setSelectedReportId(notification.reportId);
    // setIsViewOpen(true);
  };

  return (
    <div className="px-2">
      <h3 className="mb-3">Admin Notifications</h3>

      {loading && <Loader />}

      <div className="d-flex flex-column gap-2">
        {notifications.length === 0 && <div>No notifications available.</div>}

        {notifications.map((n) => (
          <div
            key={n.id}
            className={`notification-item ${!n.seen ? "unread" : ""}`}
            onClick={() => handleOpenDetails(n)}
          >
            {!n.seen && <span className="unread-dot"></span>}

            <div className="text-section">
              <div className="message">{n.message}</div>
              <div className="date">{convertMsTimeToDate(n.createdDate)}</div>
            </div>
          </div>
        ))}
      </div>

      <DetailsModal
        isViewDetailsOpen={isViewOpen}
        closeDetailsModal={() => setIsViewOpen(false)}
        reportId={selectedReportId}
      />
    </div>
  );
};

export default AdminNotifications;
